import Component from '../abstracts/Component';

export default class NewsletterPopupComponent extends Component {
    
    get SELECTORS() {
        return {
            main: '#jsNewsletter',
            closeBtn: '[data-close-popup]',
            fakeSendBtn:'.jsNewsToRegBtn',
            firstEmail:'#news-email',
            emailReg:'#email-reg',
            newsForm: '.newsletter-form',
            test:'test'
            
        };
    }
    
    constructor() {
        super();
        this.showRegisterClass = 'register-on';
    }
    
    closePopup(id){
        let popUpContainer = document.getElementById(id);
        popUpContainer.classList.remove('show');
    }
    openNewsletter(){
        let openCssClass = 'show';
        let newsEl = document.querySelector('#jsNewsletter');
        
        if( window.pageYOffset > 600){
            newsEl.classList.add(openCssClass);
        }
    }
    popUpHandler(){
        let closeBtn = document.querySelector(this.SELECTORS.closeBtn);
        let containerToClose = closeBtn.dataset.closePopup;
        closeBtn.addEventListener('click',()=>{
            this.closePopup(containerToClose);
            window.removeEventListener('scroll',this.openNewsletter);
        });
        window.addEventListener('scroll',this.openNewsletter);
    }
    
    valueFromTo(fromEl,toEl){
        let valueEl = fromEl.value;
        toEl.value = valueEl;
    }
    
    emailInputHandler(){
        let nlContainer= document.querySelector(this.SELECTORS.main);
        let newsEmailInput = document.querySelector(this.SELECTORS.firstEmail);
        let regInputEmail = document.querySelector(this.SELECTORS.emailReg);
        let sendBtn = document.querySelector(this.SELECTORS.fakeSendBtn);
        let newsForm = document.querySelector(this.SELECTORS.newsForm);
        sendBtn.addEventListener('click',(e)=>{
            if(newsForm.checkValidity()){
                e.preventDefault();
                this.valueFromTo(newsEmailInput,regInputEmail);
                nlContainer.classList.add(this.showRegisterClass);
            }else{
                return;
            }
            
        });
        
        newsEmailInput.addEventListener('keyup',(ev)=>{
            //Enter key trigger
            if((ev.which||ev.keyCode) == 13 && newsForm.checkValidity()){
                this.valueFromTo(newsEmailInput,regInputEmail);
                nlContainer.classList.add(this.showRegisterClass);
            }
        })
    }
    render() {
        this.log("Rendering...");
        if (document.querySelectorAll(this.SELECTORS.main).length) {
            this.popUpHandler();
            this.emailInputHandler();
        }
    }
}
